import { render, staticRenderFns } from "./VoteHistoryModal.vue?vue&type=template&id=06f95061&scoped=true"
import script from "./VoteHistoryModal.vue?vue&type=script&lang=js"
export * from "./VoteHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./VoteHistoryModal.vue?vue&type=style&index=0&id=06f95061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f95061",
  null
  
)

export default component.exports